import { FormControl } from '@angular/forms';
import { EntityReference } from '../../core/entities/shared/entity-reference.entity';
import { positiveOrZeroNotNull, required, requiredNotNull } from '../form-control-options.constants';
import { BaseFormControls } from './base.form-controls';

export class ShoppingSessionFormControls extends BaseFormControls {
  date = new FormControl(new Date(), requiredNotNull);
  store = new FormControl<EntityReference | null>(null, required);
  totalPrice = new FormControl(0.0, positiveOrZeroNotNull);
}
